import Country from '../models/Country';
import { parseEntity } from './commonConverters';

const SCHEMA = {
  id: 'id',
  description: 'description',
};

export function parseCountry(data: any): Country | null {
  return parseEntity(data, SCHEMA, Country);
}
